import { render, staticRenderFns } from "./ReviewCustomerDocumentsComponent.vue?vue&type=template&id=079fd295&scoped=true&"
import script from "./ReviewCustomerDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fd295",
  null
  
)

export default component.exports